const metaPadrao = {
  subject: ["PROJETO"],
  action: ["read"],
  showMenu: true,
  grupo: "CRE",
  grupoTitle: "CRE",
};

export default [
  {
    path: "cre/apontamentos",
    name: "Apontamentos",
    component: () => import("@/modules/apontamentos/views/DashboardApontamentos.view.vue"),
    meta: {
      breadcrumb: "",
      title: "Apontamentos de horas técnicas",
      icon: "mdi-timer-sand",
      subject: ["PROJETO"],
      action: ["read"],
      showMenu: true,
      grupo: "CRE",
      grupoTitle: "CRE",
    },
  },
  {
    path: "projetos-fabrica/apontamentos",
    name: "Apontamentos",
    component: () => import("@/modules/apontamentos/views/DashboardApontamentos.view.vue"),
    meta: {
      breadcrumb: "",
      title: "Apontamentos de horas técnicas",
      icon: "mdi-timer-sand",
      subject: ["PROJETO_FABRICA"],
      action: ["read"],
      showMenu: true,
      grupo: "Projetos Fábrica",
      grupoTitle: "Projetos Fábrica",
    },
  }
];
